module.exports = __webpack_public_path__ + "static/img/1.06ae24f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/sp/1.png
// module id = Sf2y
// module chunks = 0